import dialogues from 'Packages/Carbon/Carbon.Dialog/Resources/Private/Assets/Main';

const OPEN_CLASS = '-dialog-open';
const HTML_CLASS_LIST = document.documentElement.classList;

dialogues.forEach(dialog => {
    dialog.on('show', () => {
        HTML_CLASS_LIST.add(OPEN_CLASS);
    });
    dialog.on('hide', () => {
        HTML_CLASS_LIST.remove(OPEN_CLASS);
    });
});

window.emitter.on('close-dialog', () => {
    for (let index = 0; index < dialogues.length; index++) {
        const DIALOG = dialogues[index];
        if (DIALOG.shown) {
            DIALOG.hide();
            break;
        }
    }
});
